import React, { useState } from "react";
import {Container, Row, Col, Button} from "react-bootstrap";
import emailjs from 'emailjs-com';
import {Alert, Snackbar} from "@mui/material";


interface ContactFormData {
    name: string;
    email: string;
    phone: string;
    message: string;
    [key: string]: string;
}
const ContactUs: React.FC = () => {
    const [formData, setFormData] = useState<ContactFormData>({
        name: '',
        email: '',
        phone: '',
        message: '',
    });
    const [isSending, setIsSending] = useState<boolean>(false);
    const [openMsg, setOpenMsg] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');



    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSending(true);

        emailjs.send(
            'service_shxee7t',
            'template_1up0ll2',
            formData,
            '4ZdLv43nxojS47a_z'
        ).then(
            (result:any) => {
                setMessage('Message sent successfully!');
                setOpenMsg(true)
                setFormData({ name: '', email: '', phone: '', message: '' });
            },
            (error:any) => {
                console.error('Email sending error:', error);
                setMessage('Failed to send message. Please try again.');
                setOpenMsg(true)

            }
        ).finally(() => {
            setIsSending(false);
        });
    };

    return (
        <Container fluid >
            <Row className="align-items-center">
                <Col md={7}>
                    <img src="help.jpg" alt="help" className="img-fluid" />
                </Col>
                <Col md={5} className="text-center text-md-left">
                    <h2>Need Help? We’re Here!</h2>
                    <h6><span style={{fontWeight:'bold'}}>Email:</span> support@byonddigital.com</h6>
                    <h6>Book a Demo: Schedule a call with our team</h6>
                    <div className="d-flex justify-content-between flex-column align-items-stretch" style={{ maxWidth: '500px', margin: '0 auto' }}>
                        <form onSubmit={handleSubmit} className="mt-3 d-flex flex-column gap-3 w-100">
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                            <textarea
                                name="message"
                                placeholder="Message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                className="form-control"
                                rows={4}
                            />
                            <Button type="submit" disabled={isSending} variant="contained" className="w-50" style={{ backgroundColor: '#e53935', color: '#fff' }}>
                                {isSending ? 'Sending...' : 'Send Message'}
                            </Button>
                        </form>
                    </div>

                </Col>
            </Row>
            <Snackbar
                open={openMsg}
                autoHideDuration={6000}
                onClose={() => setOpenMsg(false)}
            >
                <Alert onClose={() => setOpenMsg(false)} severity="info" sx={{ width: "100%" }}>
                    {message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default ContactUs;
